module.exports = __webpack_public_path__ + "img/1746604906_Mc9d.25ce7c3d.jpg";